import { Divider as NbDivider } from '@fhs-legacy/native-base';

import { addWithConfig } from '../../utils';

export const Divider = NbDivider;

export default addWithConfig(Divider);
